import api from 'api'

export default {
    setQueryString(obj) {
        return '?' + Object.keys(obj).map(key => `${key}=${obj[key]}`).join('&')
    },
    multipleRequests(config) {
        let index = 0

        function request() {
            return api(config.method, config.url, config.arr[index]).finally(() => {
                index++
                if (index >= config.arr.length) {
                    return 'done'
                }
                return request()
            })
        }

        return request()
    },
    deepEqualMethod: (x, y) => {
        return deepEqual(x, y)
        function deepEqual(x, y) {
            if (x === y) {
                return true
            } else if ((typeof x === 'object' && x != null) && (typeof y === 'object' && y != null)) {
                if (Object.keys(x).length !== Object.keys(y).length) { return false }

                for (let prop in x) {
                    if (y.hasOwnProperty(prop)) {
                        if (!deepEqual(x[prop], y[prop])) { return false }
                    } else { return false }
                }

                return true
            } else { return false }
        }
    }
}



// WEBPACK FOOTER //
// ./src/assets/js/helper.js